<template>
  <div>
    <v-divider class="mb-5" />
    <p class="caption text--disabled">
      Talis<sup>&reg;</sup> Holzhäuser<br />
      Gehrmann u. Hinrichs GmbH & Co. KG<br />
      Johannes-Mejer-Str. 20<br />
      25813 Husum<br />
      Handelsregister Husum HRA 1841<br />
      Geschäftsführer: Bernd Hinrichs, Dipl.-Ing. Peer Gehrmann, Rafael
      Gettler<br /><br />
      www.talishaus.de<br />
      www.facebook.com/talishaus<br />
      www.instagram.com/talis.haus
    </p>
  </div>
</template>

<script>
export default {
  name: "EmailSignature",
};
</script>

<style scoped></style>
